module.exports = __webpack_public_path__ + "static/img/CC BY-ND.365d8d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cc/CC BY-ND.png
// module id = R+M4
// module chunks = 16